export default "__VITE_ASSET__pGMBgwsp__"